export var AlignItems;
(function (AlignItems) {
    AlignItems["Start"] = "start";
    AlignItems["Stretch"] = "stretch";
    AlignItems["Center"] = "center";
    AlignItems["End"] = "end";
    AlignItems["Between"] = "between";
})(AlignItems || (AlignItems = {}));
export const blockColumns = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    'half',
    'shift',
    'shift-and-half-screen',
    'full',
    'fit',
    'full-width',
];
//# sourceMappingURL=constructed-block-types.js.map